import { CookieStorage } from "aws-amplify/utils";

const SHARED_AUTH_COOKIE_DOMAIN = ".vicuscapital.com";
const SHARED_AUTH_COOKIE_EXPIRES_DAYS = 0.5;
const COGNITO_COOKIE_PREFIX = "CognitoIdentityServiceProvider.";

export function usesSharedTestAuthCookies({
  nodeEnv = process.env.NODE_ENV,
  isProposalTest = false,
} = {}) {
  return nodeEnv === "production" && isProposalTest;
}

export function getAuthCookieStorageOptions(options = {}) {
  if (!usesSharedTestAuthCookies(options)) {
    return {};
  }

  return {
    domain: SHARED_AUTH_COOKIE_DOMAIN,
    path: "/",
    expires: SHARED_AUTH_COOKIE_EXPIRES_DAYS,
    sameSite: "strict",
    secure: true,
  };
}

export function clearHostOnlyProposalTestAuthCookies({
  clientId,
  cookieString =
    typeof document === "undefined" ? "" : document.cookie || "",
  writeCookie = (value) => {
    document.cookie = value;
  },
  ...options
} = {}) {
  if (!usesSharedTestAuthCookies(options) || !clientId) {
    return [];
  }

  const expectedPrefix = `${COGNITO_COOKIE_PREFIX}${clientId}.`;
  const cookieNames = Array.from(
    new Set(
      cookieString
        .split(";")
        .map((part) => part.trim().split("=")[0])
        .filter((name) => name && name.startsWith(expectedPrefix)),
    ),
  );

  cookieNames.forEach((name) => {
    writeCookie(
      `${name}=; Path=/; Max-Age=0; SameSite=Strict; Secure`,
    );
  });

  return cookieNames;
}

export function createAuthCookieStorage(options = {}) {
  return new CookieStorage(getAuthCookieStorageOptions(options));
}
